import { render, staticRenderFns } from "./AppModalMostrarDocumentosPDF.vue?vue&type=template&id=131007de"
import script from "./AppModalMostrarDocumentosPDF.vue?vue&type=script&lang=js"
export * from "./AppModalMostrarDocumentosPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports